<iframe
    #iframe
    class="neuroglancer"
    src="neuroglancer/index.html"
    title="neuroglancer"
    autofocus
    [class.initialized]="initialized"
>
</iframe>

<div *ngIf="configSyncInProgress$ | async" class="config-sync-overlay default-loading-indicator overlay">
    <cds-progress-circle></cds-progress-circle>
    <span>Updating viewer…</span>
</div>

<div *ngIf="showEmptyState$ | async" class="empty-layers-overlay">
    <div class="empty-content">
        <p class="empty-title">No layers loaded</p>
        <p class="empty-hint">Use <strong>+</strong> on a layer group in the side panel to choose layers to load.</p>
    </div>
</div>
